import type { Grid } from './layouts';
import type { DeviceStream } from '../inventory/api';

/** Drag payloads: a camera from the list, or a tile being moved. */
export const DND_DEVICE = 'application/x-vms-device';
export const DND_TILE = 'application/x-vms-tile';

/**
 * Main stream for single views; in a mosaic the lightest profile, which keeps
 * decoding and bandwidth proportional to the tile size.
 */
export function pickStream(streams: DeviceStream[], preferLight: boolean, override?: string) {
  const usable = streams.filter((s) => s.uri);
  const chosen = override ? usable.find((s) => s.profile_token === override) : undefined;
  if (chosen) return chosen;
  if (!preferLight || usable.length < 2) return usable[0];
  const area = (s: DeviceStream) => (s.width * s.height > 0 ? s.width * s.height : Infinity);
  // No size known (RTSP-only devices): profiles come main first, so the
  // second one is the substream. Taking the main one would pull full HD for
  // every tile and saturate the site's uplink.
  if (usable.every((s) => area(s) === Infinity)) return usable[1];
  return usable.reduce((a, b) => (area(b) < area(a) ? b : a));
}

/** Grid classes of a mosaic of each size. */
export const gridCols: Record<Grid, string> = {
  1: 'grid-cols-1 grid-rows-1',
  4: 'grid-cols-2 grid-rows-2',
  9: 'grid-cols-3 grid-rows-3',
  16: 'grid-cols-4 grid-rows-4',
};
